import { PartnerFinanceMonthRewardIncome } from 'types/partnerFinance';
import { M8PartnerIncomeHistoryPaymentItem } from '../types';
import { normalizeM8DateString } from './normalizeM8DateString';

export const normalizeM8PartnerIncomeHistoryPaymentItem = (
  m8PartnerIncomeHistoryItem: M8PartnerIncomeHistoryPaymentItem
) => {
  const { id, amount, date, comment } = m8PartnerIncomeHistoryItem;

  const dateISO = normalizeM8DateString(date).toDate().toISOString();

  return {
    toPartnerFinanceMonthRewardIncome(): PartnerFinanceMonthRewardIncome {
      return {
        type: 'REWARD_INCOME',
        id,
        amount,
        dateISO,
        comment,
      };
    },
  };
};
